<template>
    <oss-dialog
        v-model="dialog"
        :title="'Ajouter un indicateur | ratio'"
        :minWidth="'800px'"
        :maxWidth="'800px'"
        :actions="actions"
        @close="reset"
        :previous-display="previousDisplay"
        @previous="previous()"
        prefixDataCy="ChoosePersonalisedCard-valid"
    >
        <v-container fluid grid-list-md>
            <v-toolbar-title v-if="!vue">Que souhaitez-vous afficher ?</v-toolbar-title>
            <v-toolbar-title v-else-if="!ratio"
                >Choisissez un indicateur à afficher</v-toolbar-title
            >
            <v-toolbar-title v-else-if="vue === 1"
                >Choisissez le type de ratio à afficher</v-toolbar-title
            >
            <v-toolbar-title v-else-if="!ratioPersonalised"
                >Choisissez le ratio qui vous interesse</v-toolbar-title
            >
            <v-toolbar-title v-else>Choisissez 2 éléments clés à comparer</v-toolbar-title>
            <v-window v-model="wizardStep" touchless class="mt-2">
                <v-window-item :value="0">
                    <v-list subheader lines="two">
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click="passerVue2SansRatio()"
                            data-cy="choosePersonalisedCard-indicator"
                        >
                            <v-list-item-title>Un Indicateur</v-list-item-title>
                            <v-list-item-subtitle
                                >Afficher un élément clé de l'entreprise (Charges sociales,
                                ...)</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click="passerVue2Ratio()"
                            data-cy="choosePersonalisedCard-ratio"
                        >
                            <v-list-item-title>Un Ratio</v-list-item-title>
                            <v-list-item-subtitle
                                >Comparer 2 indicateurs entre eux (part du loyer dans les charges,
                                ...)</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <v-window-item :value="1">
                    <!-- <v-row no-gutters class="pb-2">
                        <v-col>
                            <v-text-field-filled
                                v-model="searchBar"
                                label="Rechercher"
                                single-line
                                hide-details
                                color="primary"
                                data-cy="choosePersonalisedCard-indicator-search"
                                density="compact"
                                clearable
                                @click:clear="searchBar = ''"
                                append-inner-icon="$search"
                            />
                        </v-col>
                    </v-row> -->
                    <!-- <v-list
                        subheader
                        :style="`overflow-y: auto; height: ${listHeight}`"
                        lines="two"
                    >
                        <v-list-item
                            v-for="(type, index) in filteredAccountableKeys"
                            :key="index"
                            class="oss-list-item mb-2"
                            @click="singleSelection(type)"
                            :data-cy="'ChoosePersonalisedCard-' + index + '-TypeIndicateur'"
                        >
                            <v-list-item-title>
                                {{ caseText(type.name) }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="type.disabled" class="font-italic">
                                Cet indicateur est déjà affiché
                            </v-list-item-subtitle>

                            <template v-slot:append class="my-0">
                                <v-btn-icon
                                    v-if="!type.disabled"
                                    :icon="
                                        selectedKey === type.key
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    "
                                />
                                <v-btn-icon v-else disabled icon="$radio_button_unchecked">
                                </v-btn-icon>
                            </template>
                        </v-list-item>
                    </v-list> -->
                    <ComputedIndicatorSelector
                        :companyId="companyId"
                        @computedIndicatorSelected="addComputedIndicator($event)"
                    ></ComputedIndicatorSelector>
                </v-window-item>
                <v-window-item :value="2">
                    <v-list subheader lines="two">
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click="passerVue3RatioNonPersonalises()"
                            data-cy="ChoosePersonalisedCard-ratioPreDefini-list-item"
                        >
                            <v-list-item-title>Un ratio pré-défini</v-list-item-title>
                            <v-list-item-subtitle
                                >Afficher l'une des comparaisons les plus souvent
                                faites</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            class="oss-list-item mb-2"
                            @click="passerVue3RatioPersonalises()"
                            data-cy="ChoosePersonalisedCard-ratioPerso-list-item"
                        >
                            <v-list-item-title>Un ratio personnalisé</v-list-item-title>
                            <v-list-item-subtitle
                                >Comparer 2 indicateurs que vous choisissez</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-next />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <v-window-item :value="3">
                    <ComputedIndicatorSelector
                        :companyId="companyId"
                        :definedOperator="'v1/v2'"
                        :operatorsWanted="['v1/v2']"
                        :dontAllowCreation="true"
                        @computedIndicatorSelected="addComputedIndicator($event)"
                    ></ComputedIndicatorSelector>
                    <!-- <v-row no-gutters>
                        <v-col
                            d-flex
                            class="font-weight-bold justify-center"
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                            data-cy="ChoosePersonalisedCard-TypeRatio-perso"
                        >
                            Ratio : {{ selectedName }} / {{ secondSelectedName }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pb-2">
                        <v-col>
                            <v-text-field-filled
                                v-model="searchBar"
                                label="Rechercher"
                                single-line
                                hide-details
                                color="primary"
                                data-cy="choosePersonalisedCard-ratio-search"
                                density="compact"
                                clearable
                                @click:clear="searchBar = ''"
                                append-inner-icon="$search"
                            />
                        </v-col>
                    </v-row>
                    <v-list
                        subheader
                        :style="`overflow-y: auto; height: ${listHeight}`"
                        lines="two"
                    >
                        <v-list-item
                            v-for="(type, index) in filteredListRatios"
                            :key="index"
                            class="oss-list-item mb-2"
                            @click="ratioSelection(type)"
                        >
                            <v-list-item-title
                                :data-cy="'ChoosePersonalisedCard-TypeRatio-' + index + '-defini'"
                            >
                                {{ type.ratioName }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="type.disabled" class="font-italic">
                                Ce ratio est déjà affiché
                            </v-list-item-subtitle>
                            <template v-slot:append class="my-0">
                                <v-btn-icon
                                    v-if="!type.disabled"
                                    :icon="
                                        selectedRatio === type.ratioName
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    "
                                >
                                </v-btn-icon>
                                <v-btn-icon v-else disabled icon="$radio_button_unchecked">
                                </v-btn-icon>
                            </template>
                        </v-list-item>
                    </v-list> -->
                </v-window-item>
                <v-window-item :value="4">
                    <ComputedIndicatorSelector
                        :companyId="companyId"
                        :definedOperator="'v1/v2'"
                        :actions="CI_selectorActions"
                        @computedIndicatorSelected="createRatio($event)"
                    ></ComputedIndicatorSelector>
                    <!-- <v-row no-gutters>
                        <v-col
                            d-flex
                            class="font-weight-bold justify-center"
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                        >
                            Ratio : {{ selectedName }} / {{ secondSelectedName }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pb-2">
                        <v-col>
                            <v-text-field-filled
                                v-model="searchBar"
                                label="Rechercher"
                                single-line
                                hide-details
                                color="primary"
                                density="compact"
                                clearable
                                @click:clear="searchBar = ''"
                                append-inner-icon="$search"
                            />
                        </v-col>
                    </v-row>
                    <v-list
                        subheader
                        :style="`overflow-y: auto; height: ${listHeight}`"
                        lines="two"
                    >
                        <v-list-item
                            v-for="type of filteredAccountableKeys"
                            :key="type.key"
                            class="oss-list-item mb-2"
                            data-cy="ChoosePersonalisedCard-TypeRatio-list-item"
                        >
                            <v-list-item-title
                                data-cy="ChoosePersonalisedCard-TypeRatio-list-item-title"
                            >
                                {{ type.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="type.disabledForRatio" class="font-italic">
                                Ce ratio est déjà affiché
                            </v-list-item-subtitle>

                            <template v-slot:prepend>
                                <v-checkbox
                                    v-model="selectedKeys"
                                    :value="type"
                                    @change="doubleSelection(type.key, type.name)"
                                    :disabled="type.disabledForRatio"
                                    hide-details
                                    data-cy="ChoosePersonalisedCard-TypeRatio-btn"
                                />
                            </template>
                        </v-list-item>
                    </v-list> -->
                </v-window-item>
            </v-window>
        </v-container>
    </oss-dialog>
</template>

<script lang="ts">
// import { Apollo } from "@/decorators";
import gql from "graphql-tag";

import ComputedIndicatorSelector from "./computedIndicator/ComputedIndicatorSelector.vue";

// import PUBLIC_KEYS from "../graphql/dashboardAccounting/PublicKeys.gql";
// import CREATE_DASHBOARD_SETTING from "../graphql/dashboard/CreateDashboardSetting.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import { DialogAction } from "../services/dialogAction";

@Component({
    components: {
        ComputedIndicatorSelector,
    },
    emits: ["update_dashboardSettings"],
})
export class ChoosePersonalisedCard extends Vue {
    @Prop({ default: null }) settingsPersonalisedCards: any; // obligatoire
    @Prop({ default: null }) companyId: Array<{}>; // obligatoire
    @Model() value: boolean;

    selectedKeys = [];

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get actions() {
        if (this.wizardStep === 4) {
            return this.CI_selectorActions;
        } else {
            const actions = {
                action: new DialogAction(),
            };
            actions.action.disabled = this.wizardStep === 0 || this.wizardStep === 2;
        }
    }

    CI_selectorActions = {
        action: new DialogAction(),
    };

    vue = 0; // 1 quand on est dans la deuxième fenetre du dialog et 2 quand on est dans la 3ème page (uniquement pour la partie Ratio)
    ratio = false; // true quand on est dans la vue 'Ratio' (par opposé à la vue 'Amount')
    ratioPersonalised = false; // true quand on est dans la fenetre ratioPersonalisé (3ème page)
    selectedKey = ""; // 1ère clé de compte comptable sélectionnée par l'utilisateur
    secondSelectedKey = ""; // 2ème clé (dans le cas de ratio entre 2 clés comptes comptables)
    selectedName = "";
    secondSelectedName = "";
    selectedRatio = "";
    searchBar = "";
    wizardStep = 0;

    caseText(name) {
        // si les name dans general.ts venaient à être homogénéisés (sans Maj) on pourrait supprimer cette fonction
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }

    passerVue2SansRatio() {
        this.wizardStep = 1;
        this.vue = 1;
        this.ratio = false;
        this.selectedKey = "";
        this.selectedName = "";
        this.secondSelectedName = "";
        this.secondSelectedKey = "";
        this.searchBar = "";
    }

    passerVue2Ratio() {
        this.vue = 1;
        this.wizardStep = 2;
        this.ratio = true;
    }

    passerVue3RatioNonPersonalises() {
        this.vue = 2;
        this.wizardStep = 3;
        this.ratio = true;
        this.ratioPersonalised = false;
        this.selectedRatio = "";
        this.searchBar = "";
    }

    passerVue3RatioPersonalises() {
        this.vue = 2;
        this.wizardStep = 4;
        this.ratio = true;
        this.ratioPersonalised = true;
        this.selectedKey = "";
        this.selectedName = "";
        this.secondSelectedName = "";
        this.secondSelectedKey = "";
        this.searchBar = "";
    }

    mainAccountableKeys: any = [];

    // keysAlreadyUsed() {
    //     // liste des clés déjà affichées sous card Amount (pour éviter les doublons des cards Amount dans le dashboard)
    //     for (const cardAlreadyUsed of this.settingsPersonalisedCards) {
    //         if (cardAlreadyUsed.key2 === "") {
    //             const ak = this.mainAccountableKeys.find((mak) => mak.key === cardAlreadyUsed.key1);
    //             if (ak) {
    //                 ak.disabled = true;
    //                 // { key: this.mainAccountableKeys[i].key, name: this.mainAccountableKeys[i].name, disabled: true }
    //                 // si mainAccountableKeys[i] = disabled => impossible à sélectionner dans vue et affiche 'déjà utilisé'
    //             } else {
    //                 debugger;
    //             }
    //         }
    //     }
    // }

    async addComputedIndicator(computedIndicator) {
        if (computedIndicator?.id) {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation ($computedIndicatorId: ID!, $companyId: ID!) {
                        updateComputedIndicator(
                            where: { id: $computedIndicatorId }
                            data: { companies: { connect: { id: $companyId } } }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    companyId: this.companyId,
                    computedIndicatorId: computedIndicator.id,
                },
            });
            this.$emit("update_dashboardSettings");
            this.reset();
            // this.$apollo.queries.mainAccountableKeys.refetch();
            this.dialog = false;
        } else {
            debugger;
        }
    }

    async createRatio(selectedIndicators) {
        const resultDefinition = {
            values: [
                selectedIndicators[0].definition.values[0],
                selectedIndicators[1].definition.values[0],
            ],
            operator: "v1/v2",
        };
        resultDefinition.values[1].operationName = "v2";
        await this.$apollo.mutate({
            mutation: gql`
                mutation ($definition: Json, $companyId: ID!) {
                    createComputedIndicator(
                        data: {
                            definition: $definition
                            companies: { connect: { id: $companyId } }
                        }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                companyId: this.companyId,
                definition: resultDefinition,
            },
        });
        this.$emit("update_dashboardSettings");
        this.reset();
        // this.$apollo.queries.mainAccountableKeys.refetch();
        this.dialog = false;
    }

    reset() {
        this.wizardStep = 0;
        this.vue = 0;
        this.ratio = false;
        this.ratioPersonalised = false;
        this.reinitialisationSelection();
    }

    reinitialisationSelection() {
        this.selectedKey = "";
        this.selectedName = "";
        this.secondSelectedName = "";
        this.secondSelectedKey = "";
        this.selectedRatio = "";
    }

    get previousDisplay() {
        return !!this.vue;
    }

    previous() {
        this.vue--;
        this.ratioPersonalised = false;
        this.reinitialisationSelection();
        switch (this.wizardStep) {
            case 1: {
                this.wizardStep = 0;
                break;
            }
            case 2: {
                this.wizardStep = 0;
                break;
            }
            case 3: {
                this.wizardStep = 2;
                break;
            }
            case 4: {
                this.wizardStep = 2;
                break;
            }
        }
    }

    windowHeight = window.innerHeight;

    beforeMount() {
        window.addEventListener(
            "resize",
            () => {
                this.windowHeight = window.innerHeight;
            },
            true,
        );
    }

    get listHeight() {
        let maxHeight = this.windowHeight - (28 + 16 * 2);
        maxHeight -= 68;
        maxHeight -= 185;
        maxHeight -= 56;
        return maxHeight + "px;";
    }
}

export default toNative(ChoosePersonalisedCard);
</script>
